module.exports = __webpack_public_path__ + "img/violet-5.c7f1bbb2.png";